const coreName = {
  BASE: 'Core',
  TOOLS: undefined
}
coreName.MAIN = `${coreName.BASE}|Tools`

export default {
  ...coreName
}
